import { BookmarkPage, Course, Enum_Bookmark_Category } from '@edwin-group/cj-graphql';
import CourseCard from '@/components/Card-v5/Course';
import { useBookmark } from '../../hooks/useBookmark';
import { BookmarkListCard } from '../shared/BookmarkListCard';
import { buildBookmarkFilters } from '../../utils/buildBookmarkFilters';
import { formatTitle } from '../../utils/formatTitle';

interface CourseBookmarkListCardProps {
  category: Enum_Bookmark_Category;
  page: BookmarkPage;
}

export default function CourseBookmarkListCard({ category, page }: CourseBookmarkListCardProps) {
  const filters = buildBookmarkFilters({ category });
  const { data, refetch } = useBookmark<Course>(filters);

  return (
    <BookmarkListCard
      title={formatTitle(category)}
      data={data || []}
      page={page}
      showDivider={false}
      renderCard={(course: Course) => (
        <CourseCard
          course={course}
          key={course?.slug}
          showBookmarkIcon
          onRemoveFromBookmark={refetch}
          buttonText={page?.openButtonTxt || ''}
        />
      )}
    />
  );
}
